import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const LinkedInIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M27.2622 27.2693H22.5244V19.8436C22.5244 18.0729 22.4889 15.7938 20.0533 15.7938C17.584 15.7938 17.2071 17.7209 17.2071 19.7138V27.2693H12.4676V12H17.0187V14.08H17.0809C17.7173 12.8818 19.264 11.6142 21.5751 11.6142C26.3751 11.6142 27.264 14.7751 27.264 18.8871V27.2693H27.2622ZM7.11644 9.91111C6.75477 9.91158 6.39655 9.84066 6.06233 9.70241C5.72812 9.56417 5.42448 9.36131 5.16881 9.10549C4.91315 8.84966 4.71049 8.54588 4.57246 8.21158C4.43443 7.87727 4.36374 7.51901 4.36444 7.15733C4.3648 6.61304 4.52654 6.08107 4.82923 5.6287C5.13191 5.17634 5.56195 4.82388 6.06494 4.61592C6.56794 4.40795 7.12131 4.35381 7.65508 4.46034C8.18884 4.56687 8.67903 4.82929 9.06366 5.21441C9.44828 5.59953 9.71007 6.09006 9.81591 6.62397C9.92175 7.15787 9.8669 7.71117 9.65828 8.2139C9.44966 8.71663 9.09665 9.1462 8.6439 9.4483C8.19114 9.7504 7.66074 9.91146 7.11644 9.91111ZM9.49156 27.2693H4.73956V12H9.49333V27.2693H9.49156ZM29.6356 0H2.36267C1.05422 0 0 1.03111 0 2.30578V29.6942C0 30.9689 1.056 32 2.36089 32H29.6284C30.9333 32 32 30.9689 32 29.6942V2.30578C32 1.03111 30.9333 0 29.6284 0H29.6356Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default LinkedInIcon;
